export default __webpack_public_path__ + "static/media/swap.3656a63b.svg";